import apiClient from './apiClient'


const sendMessage = (data) => {
  return apiClient.post('/contactUs', data, { auth: false })
}



export default {
  sendMessage
}
